import { render } from "./ChangeBrowser.vue?vue&type=template&id=6e301eb7"
import script from "./ChangeBrowser.vue?vue&type=script&lang=js"
export * from "./ChangeBrowser.vue?vue&type=script&lang=js"

import exportComponent from "/Users/documedias/gitlab/virtuell/unionconf2025/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__